import { IPageResponse } from '@/types/common.types';
import { axiosInstance } from '@/services/axios-instance';
import type {
  IConversation,
  IMessage,
  IMessageGroup,
  IMessageGroupListParams,
} from '@/services/messaging/types';

export const getMessageGroups = async (
  params: IMessageGroupListParams
): Promise<IPageResponse<IMessageGroup>> => {
  return axiosInstance.get('/message-groups', {
    params,
  });
};

export const getConversation = async (id: string): Promise<IConversation> => {
  return axiosInstance.get(`/message-groups/${id}`);
};

export const getConversationMessages = async (
  id: string
): Promise<IPageResponse<IMessage>> => {
  return axiosInstance.get(`/message-groups/${id}/messages`);
};

export const sendMessage = async (
  id: string,
  content?: string,
  file?: string
): Promise<IMessage> => {
  return axiosInstance.post(`/message-groups/${id}/messages`, {
    content,
    file,
  });
};

export const readMessage = async (
  groupId: string,
  messageId: string
): Promise<void> => {
  return axiosInstance.post(
    `/message-groups/${groupId}/messages/${messageId}/read`
  );
};
